import { useMutation, useQueryClient } from '@tanstack/react-query'

import { UsersService } from '../lib/users.service'
import { INVITES_LIST_QUERY_KEY } from './useInvites'

export const useInviteDelete = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (inviteId: string) => UsersService.deleteInvite(inviteId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [INVITES_LIST_QUERY_KEY]
      })
    }
  })
}
